import Vue from 'vue'
import Hotjar from 'vue-hotjar'

Vue.use(Hotjar, {
  id: process.env.HOTJAR_SITE_ID,
  isProduction: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/plugins/hotjar.js